export const RIA = 'REDIRECT_IF_AUTHORIZED';
export const RINA = 'REDIRECT_IF_NOT_AUTHORIZED';
